import { c as _c } from "react/compiler-runtime";
import { ReactElement, memo } from 'react';
import ProductAttributeTileComponent from '../product-attribute-tile/product-attribute-tile.component';
import classNames from 'clsx';
import styles from './product-attribute-tile-list.component.module.scss';
export interface Props {
  readonly attributeTiles: Array<ProductAttributeTileData>;
  readonly isScrollable: boolean;
  readonly selectedAttributeTileName: string;
}
export interface ProductAttributeTileData {
  readonly element?: ReactElement;
  readonly isAvailable: boolean;
  readonly name: string;
  readonly path?: string;
}
function ProductAttributeTileListComponent(t0) {
  const $ = _c(10);
  const {
    attributeTiles,
    isScrollable,
    selectedAttributeTileName
  } = t0;
  let t1;
  if ($[0] !== selectedAttributeTileName) {
    t1 = t2 => {
      const {
        element,
        isAvailable,
        name,
        path
      } = t2;
      return <ProductAttributeTileComponent key={name} element={element} isAvailable={isAvailable} isSelected={name === selectedAttributeTileName} name={name} path={path} />;
    };
    $[0] = selectedAttributeTileName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const renderProductAttributeTileComponent = t1;
  let t2;
  if ($[2] !== isScrollable) {
    t2 = classNames(styles["product-attribute-tile-list"], {
      [styles["product-attribute-tile-list--scrollable"]]: isScrollable
    });
    $[2] = isScrollable;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== attributeTiles || $[5] !== renderProductAttributeTileComponent) {
    t3 = attributeTiles.map(renderProductAttributeTileComponent);
    $[4] = attributeTiles;
    $[5] = renderProductAttributeTileComponent;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export default memo(ProductAttributeTileListComponent);